
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model} from '../../controlador-crear-curso';
    import editar from './cursos-crear-preguntas-editar.vue';
    import { Recurso } from '@/__env/lib/Cursos/Recursos';
    import { Wait } from '@/__env/ext';
    import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
    import { Curso } from '@/__env/lib/Cursos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            editar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public ReadOnly: boolean;

        public get Controlador() { return Model; }

        @Prop()
        public Curso: Curso;


        public EditandoPregunta: Pregunta = null;
        public Editando: boolean = false;

        public Agregar( pregunta: Pregunta )
        {
            let idx = this.Curso.Preguntas.findIndex( x => pregunta.Id == x.Id );
            if ( idx != -1 )
            {
                pregunta.Posicion = this.Curso.Preguntas[idx].Posicion;
                this.Curso.Preguntas.splice( idx, 1 );
            }
            else
            {
                pregunta.Posicion = this.Preguntas.length + 1;
            }
            this.Curso.Preguntas.push( pregunta );

            this.Controlador.$emit( 'change' );
        }

        public Crear()
        {
            this.EditandoPregunta = null;
            this.Editando = !this.Editando;
        }

        public Eliminar( index: number )
        {
            this.Curso.Preguntas.splice( index, 1 );
            this.Preguntas.forEach( ( x, index ) => x.Posicion = index + 1 );
            this.Controlador.$emit( 'change' );

        }

        public get Preguntas(): Pregunta[]
        {
            return this.Curso.Preguntas.sort( ( x, y ) => x.Posicion - y.Posicion );
        }

        public Editar( p: Pregunta )
        {
            this.EditandoPregunta = p;
            this.Editando = !this.Editando;
        }

        async Subir( p: Pregunta )
        {
            if ( p.Posicion > 1 )
            {
                p.Posicion--;
                p.Posicion -= 0.5;
                this.Controlador.$emit( 'change' );
                await Wait( 100 );
                this.$nextTick( () =>
                {
                    this.Preguntas.forEach( ( x, index ) => x.Posicion = index + 1 );
                    this.Controlador.$emit( 'change' );
                } );
            }
        }
        async Bajar( p: Pregunta )
        {
            if ( p.Posicion > 0 && p.Posicion < this.Preguntas.length )
            {
                p.Posicion++;
                p.Posicion += 0.5;
                this.Controlador.$emit( 'change' );
                await Wait( 100 );
                this.$nextTick( () =>
                {
                    this.Preguntas.forEach( ( x, index ) => x.Posicion = index + 1 );
                    this.Controlador.$emit( 'change' );
                } );
            }
        }

    }
